/* eslint-disable func-names */
import { toast } from 'react-toastify';
import { actionForState } from '../../../utils/helpers';
import {
  FETCH_ADP_LOGS,
  INITIATE_APPLICATION,
  CHECK_APPROVED_APP,
  AVP_CHECK_APPROVED_APP_BY_FIELD,
  CLEAR_APPROVAL_APPLICATION_LIST_BY_FIELD,
  CLEAR_APPROVED_APPLICATION_STATE,
  FETCH_SPECIFIC_ADP_LOGS,
  FETCH_DRAFT,
  CLEAR_DRAFT_STATE,
  INITIATE_DRAFT_APPLICATION,
  FETCH_AVP_LOGS,
  FETCH_SPECIFIC_AVP_LOGS,
  ADP_DEFAULT_FIELDS,
  INITIATE_AVP_APPLICATION,
  AVP_DEFAULT_FIELDS,
  GET_AVP_CATEGORIES,
  GET_AVP_FEE_MATRIX,
  MAKE_AVP_PAYMENT,
  ADP_AVP_CANCEL_APPLICATION,
  DELETE_SPECIFIC_ADP_LOGS,
  FETCH_USER_APPLICATIONS,
  RENEWAL_DAYS,
  AVP_GLOBAL_DATASOURCE_LIST,
  SAVE_AS_DRAFT,
  GET_ADP_CATEGORIES,
  ADP_SUSPEND_ACTION,
  CLEAR_DETAILS,
  CLEAR_ADP_DETAILS_STATUS,
  ADP_REVOKE_ACTION,
  AVP_SUSPEND_ACTION,
  AVP_REVOKE_ACTION,
  CLEAR_CANCEL_STATE,
  GET_ADP_APPLICATION_STAGE,
  CLEAR_STAGES_STATE,
  ADP_RE_APPLY,
  AVP_RE_PRINT,
  ADP_RE_PRINT,
  FETCH_SCHEDULES,
  CLEAR_BOOKING_SCHEDULE,
  SCHEDULE_APPOINTMENT,
  RESCHEDULE_APPOINTMENT,
  FETCH_SCHEDULE_SLOTS_BY_DATE,
  CLEAR_STATE,
  CLEAR_PAYMENT_STATE,
  GET_DEFECT_VEHICLES,
  GET_DEFECT_VEHICLE_DETAIL,
  UPDATE_MAINTENANCE,
  POST_COMMENTS,
  GET_COMMENTS,
  GET_MY_APPLICATIONS,
  GET_PORTAL_USERS,
  GET_APPLICATION_DETAILS,
  GET_ADP_EXTERNAL_TRAINING,
  UPDATE_DP,
  RETAKE_TRAINING,
  SUBMIT_DP,
  EMPTY_UPDATE_DP,
  APPEAL_VIOLATION,
  AVP_RE_APPLY,
  GET_CURRENT_TENANT_PORTAL_USERS,
  UPDATE_REQUIRED_DOCUMENTS,
  IMPORT_AVP_LOGS_DATA,
  CLEAR_IMPORT_AVP_STATE,
  UPLOAD_AVP_ATTACHMENTS,
  AVP_DRAFT_APPLICATION,
  CHECK_INITIATE_PERMIT,
  GET_TENANT_MANDATORY_DOCUMENTS,
  CLEAR_MANDATORY_DOCUMENT_ACTIONS,
  CLEAR_APPLICATION_SUCCESS_RESPONSE,
  CLEAR_INITIATED_PERMIT_STATE,
  DELETE_SAVE_AS_DRAFT_ADP_LOGS,
  DELETE_SAVE_AS_DRAFT_AVP_LOGS,
  CLEAR_APPLICATION_STATUS,
  GET_LOGS_EXCEL_EXPORT,
  FETCH_AVP_LOGS_TO_EXPORT,
  CLEAR_REPRINT_STATE,
  MAKE_ADP_PAYMENT,
  GET_AVP_COMMENTS,
  ADDITIONAL_DRIVER_PERMIT_DOCS,
  ADDITIONAL_VEHICLE_PERMIT_DOCS
} from './types';
import { PERMIT_ALREADY_RENEWED } from '../constant';

const INITIAL_STATE = {
  Adp_logs: [],
  Avp_logs: [],
  specificLog: {},
  renewaldays: {},
  errorResponse: undefined,
  schedulingErrorResponse: undefined,
  currentPage: false,
  avpDefaultFields: false,
  userData: {},
  totalLogsCount: 0,
  totalAvpLogsCount: 0,
  adpInitiationStatus: {
    loading: false,
    success: false,
    error: false
  },
  avpInitiationStatus: {
    loading: false,
    success: false,
    error: false
  },
  checkApprovedApplicationAction: {
    loading: false,
    success: false,
    error: false
  },
  additionalDocsAction: {
    loading: false,
    success: false,
    error: false
  },
  actionForApprovedAppCheck: {
    loading: false,
    success: false,
    error: false
  },
  approvedApplicationData: {},
  checkInitiatedPermitAction: {
    loading: false,
    success: false,
    error: false
  },
  actionGetMandatoryDocuments: {
    loading: false,
    success: false,
    error: false
  },
  hasPermissionToInitiateApplication: true,
  initiatedPermitData: {},
  suspendApplicationAction: {
    loading: false,
    success: false,
    error: false
  },
  defectVehiclesAction: {
    loading: false,
    success: false,
    error: false
  },
  defectVehicleAction: {
    loading: false,
    success: false,
    error: false
  },
  commentDefectAction: {
    loading: false,
    success: false,
    error: false
  },
  getcommentDefectAction: {
    loading: false,
    success: false,
    error: false
  },
  updateDefectAction: {
    loading: false,
    success: false,
    error: false
  },
  revokeApplicationAction: {
    loading: false,
    success: false,
    error: false
  },
  violationAppealAction: {
    loading: false,
    success: false,
    error: false
  },
  actionSaveAsDraft: {
    loading: false,
    success: false,
    error: false
  },
  suspendAVPApplicationAction: {
    loading: false,
    success: false,
    error: false
  },
  initiateDraftApplicationAction: {
    loading: false,
    success: false,
    error: false
  },
  revokeAVPApplicationAction: {
    loading: false,
    success: false,
    error: false
  },
  avpSpecificLog: {},
  deletionStatus: {
    loading: false,
    success: false,
    error: false
  },
  avpNotes: [],
  avpCustomFields: [],
  adpAvpCancelAplicationAction: {
    loading: false,
    success: false,
    error: false
  },
  renewalStatus: {
    loading: false,
    success: false,
    error: false
  },
  adp_Reapply_Status: {
    loading: false,
    success: false,
    error: false
  },
  avpRePrintStatus: {
    loading: false,
    success: false,
    error: false
  },
  adpRePrintStatus: {
    loading: false,
    success: false,
    error: false
  },
  actionScheduleSlotsFetch: {
    loading: false,
    success: false,
    error: false
  },
  actionScheduleFetch: {
    loading: false,
    success: false,
    error: false
  },
  actionScheduled: {
    loading: false,
    success: false,
    error: false
  },
  actionRescheduled: {
    loading: false,
    success: false,
    error: false
  },
  userApplications: [],
  myApplications: [],
  actionMyApplications: {
    loading: false,
    success: false,
    error: false
  },
  portalUsers: [],
  actionPortalUsers: {
    loading: false,
    success: false,
    error: false
  },
  applicationDetails: {},
  actionApplicationDetails: {
    loading: false,
    success: false,
    error: false
  },
  actionUpdateDP: {
    loading: false,
    success: false,
    error: false
  },
  actionRetakeTraining: {
    loading: false,
    success: false,
    error: false
  },
  updatedDp: {},
  actionSubmitDp: {
    loading: false,
    success: false,
    error: false
  },
  importAvpdataAction: {
    success: false,
    loading: false,
    error: false
  },
  actionDeleteDraftADPApplication: {
    loading: false,
    success: false,
    error: false
  },
  actionDeleteDraftAVPApplication: {
    loading: false,
    success: false,
    error: false
  },
  submittedDp: {},
  scheduledSlot: {},
  isScheduleEnable: false,
  currentTenantPortalUsers: []
};


export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_ADP_LOGS.pending:
      return {
        ...state,
        deletionStatus: {
          loading: true,
          success: false,
          error: false
        },
        actionPortalTrainingsFetch: actionForState(state.action, 'pending')
      };
    case FETCH_ADP_LOGS.success:
      return {
        ...state,
        deletionStatus: {
          loading: false,
          success: true,
          error: false
        },
        adpInitiationStatus: {
          loading: false,
          success: false,
          error: false
        },
        Adp_logs: action?.payload?.results,
        enable_initial_review: action?.payload?.enable_initial_review || false,
        scheduleEnable: action?.payload?.scheduleEnable || false,
        Adp_summary: action?.payload?.summary,
        Adp_filteroptions: action?.payload?.filter_options,
        totalLogsCount: action?.payload?.count,
        actionPortalTrainingsFetch: actionForState(state.action, 'success')
      };
    case FETCH_ADP_LOGS.error:
      return {
        ...state,
        deletionStatus: {
          loading: false,
          success: false,
          error: true
        },
        actionPortalTrainingsFetch: actionForState(state.action, 'error')
      };
    case INITIATE_APPLICATION.pending:
      return {
        ...state,
        adpInitiationStatus: {
          loading: true,
          success: false,
          error: false
        },
        actionPortalTrainingsFetch: actionForState(state.action, 'pending')
      };
    case INITIATE_APPLICATION.success:
      return {
        ...state,
        adpInitiationStatus: {
          loading: false,
          success: true,
          error: false
        },
        getApplicationResponse: action.payload || {},
        actionPortalTrainingsFetch: actionForState(state.action, 'success')
      };
    case INITIATE_APPLICATION.error:
      if (action.payload?.response?.data?.detail !== PERMIT_ALREADY_RENEWED) {
        toast.error('Please try after some time');
      }
      return {
        ...state,
        adpInitiationStatus: {
          loading: false,
          success: false,
          error: true
        },
        errorResponse: action.payload?.response?.data?.detail,
        actionPortalTrainingsFetch: actionForState(state.action, 'error')
      };

      case CHECK_APPROVED_APP.pending: {
        return {
          ...state,
          checkApprovedApplicationAction: actionForState(state.action, 'pending')
        };
      }

      case CHECK_APPROVED_APP.success: {
        return {
          ...state,
          checkApprovedApplicationAction: actionForState(state.action, 'success'),
          approvedApplicationData: action.payload
        };
      }

      case CHECK_APPROVED_APP.error: {
        toast.error('Please try again later');
        return {
          ...state,
          checkApprovedApplicationAction: actionForState(state.action, 'error')
        };
      }

    case AVP_CHECK_APPROVED_APP_BY_FIELD.pending: {
      return {
        ...state,
        actionForApprovedAppCheck: actionForState(state.action, 'pending')
      };
    }

    case AVP_CHECK_APPROVED_APP_BY_FIELD.success: {
      return {
        ...state,
        actionForApprovedAppCheck: actionForState(state.action, 'success'),
        approvedApplicationData: action.payload
      };
    }

    case AVP_CHECK_APPROVED_APP_BY_FIELD.error: {
      toast.error('Please try again later');
      return {
        ...state,
        actionForApprovedAppCheck: actionForState(state.action, 'error')
      };
    }

    case CLEAR_APPROVAL_APPLICATION_LIST_BY_FIELD: {
      return {
        ...state,
        actionForApprovedAppCheck: {
          loading: false,
          success: false,
          error: false
        },
        approvedApplicationData: {}
      };
    }

    case GET_TENANT_MANDATORY_DOCUMENTS.pending:
      return {
        ...state,
        actionGetMandatoryDocuments: actionForState(state.action, 'pending')
      };
    case GET_TENANT_MANDATORY_DOCUMENTS.success: {
      return {
        ...state,
        actionGetMandatoryDocuments: actionForState(state.action, 'success'),
        hasPermissionToInitiateApplication: !action.payload?.documents?.length
      };
    }
    case GET_TENANT_MANDATORY_DOCUMENTS.error: {
      toast.error('Please try again later');
      return {
        ...state,
        actionGetMandatoryDocuments: actionForState(state.action, 'error')
      };
    }

    case CLEAR_MANDATORY_DOCUMENT_ACTIONS: {
      let { hasPermissionToInitiateApplication } = state;
      if (action.info?.isCloseOpenModal) {
        hasPermissionToInitiateApplication = true;
      }
      return {
        ...state,
        actionGetMandatoryDocuments: {
          loading: false,
          success: false,
          error: false
        },
        hasPermissionToInitiateApplication
      };
    }

    case CLEAR_APPLICATION_SUCCESS_RESPONSE: {
      return {
        ...state,
        avpInitiationInfo: {}
      };
    }

    case CHECK_INITIATE_PERMIT.pending: {
      return {
        ...state,
        checkInitiatedPermitAction: actionForState(state.action, 'pending')
      };
    }

    case CHECK_INITIATE_PERMIT.success: {
      return {
        ...state,
        checkInitiatedPermitAction: actionForState(state.action, 'success'),
        initiatedPermitData: action.payload
      };
    }

    case CHECK_INITIATE_PERMIT.error: {
      toast.error('Please try again later');
      return {
        ...state,
        checkInitiatedPermitAction: actionForState(state.action, 'error')
      };
    }

    case GET_ADP_CATEGORIES.pending:
      return {
        ...state,
        actionGetCategories: actionForState(state.action, 'pending')
      };
    case GET_ADP_CATEGORIES.success: {
      let adpCategoriesList = [...(state.adpCategories || [])] || [];
      let adpFeetypesList = state.adpFeetypesList || [];
      let adpFeeWithCategoriesList = state.adpFeeWithCategoriesList || [];
      if (action.apiInfo?.category) {
        adpCategoriesList = action?.payload;
      } else if (action.apiInfo?.fee_types) {
        adpFeetypesList = action?.payload;
      } else {
        adpFeeWithCategoriesList = action.payload;
      }
      return {
        ...state,
        adpCategories: adpCategoriesList,
        adpFeetypesList,
        adpFeeWithCategoriesList,
        actionGetCategories: actionForState(state.action, 'success')
      };
    }
    case GET_ADP_CATEGORIES.error:
      return {
        ...state,
        actionGetCategories: actionForState(state.action, 'error')
      };

    case FETCH_SPECIFIC_ADP_LOGS.pending:
      return {
        ...state,
        loading: false,
        loader: true,
        getADPdetailsStatus: actionForState(state.action, 'pending'),
        actionPortalTrainingsFetch: actionForState(state.action, 'pending')
      };
    case FETCH_SPECIFIC_ADP_LOGS.success:
      return {
        ...state,
        specificLog: action.payload,
        adpSettings: action.payload?.settings,
        adpDSchema: action.payload?.schema?.default_fields?.default_field || [],
        adpCSchema: action.payload?.schema?.schema?.fields || [],
        adpOrder: action.payload?.schema?.schema?.ordering || [],
        loader: false,
        actionPortalTrainingsFetch: actionForState(state.action, 'success'),
        getADPdetailsStatus: actionForState(state.action, 'success'),
        suspendApplicationAction: {
          loading: false,
          success: false,
          error: false
        },
        revokeApplicationAction: {
          loading: false,
          success: false,
          error: false
        },
        suspendAVPApplicationAction: {
          loading: false,
          success: false,
          error: false
        },
        revokeAVPApplicationAction: {
          loading: false,
          success: false,
          error: false
        },
        adpAvpCancelAplicationAction: {
          loading: false,
          success: false,
          error: false
        }

      };
    case FETCH_SPECIFIC_ADP_LOGS.error:
      toast.error('Please try again some time');
      return {
        ...state,
        loader: false,
        specificLog: {},
        getADPdetailsStatus: actionForState(state.action, 'error'),
        actionPortalTrainingsFetch: actionForState(state.action, 'error')
      };
    case MAKE_ADP_PAYMENT.pending: {
      return {
        ...state,
        makeAdpPaymentAction: actionForState(state.action, 'pending')
      };
    }
    case MAKE_ADP_PAYMENT.success: {
      return {
        ...state,
        makeAdpPaymentAction: actionForState(state.action, 'success'),
        paymentRedirectUrl: action.payload?.tns_session_url || '',
        adpPaymentDetail: action.payload?.detail || ''
      };
    }
    case MAKE_ADP_PAYMENT.error: {
      return {
        ...state,
        makeAdpPaymentAction: actionForState(state.action, 'error')
      };
    }
    case FETCH_DRAFT.pending:
      return {
        ...state,
        actionPortalTrainingsFetch: actionForState(state.action, 'pending')
      };
    case FETCH_DRAFT.success:
      return {
        ...state,
        specificLog: action.payload,
        actionPortalTrainingsFetch: actionForState(state.action, 'success')
      };
    case FETCH_DRAFT.error:
      return {
        ...state,
        actionPortalTrainingsFetch: actionForState(state.action, 'error')
      };
    case GET_ADP_EXTERNAL_TRAINING.pending:
      return {
        ...state,
        actionGetExternalTraining: actionForState(state.action, 'pending')
      };
    case GET_ADP_EXTERNAL_TRAINING.success:
      return {
        ...state,
        externalTrainingRecords: action.payload,
        actionGetExternalTraining: actionForState(state.action, 'success')
      };
    case GET_ADP_EXTERNAL_TRAINING.error:
      return {
        ...state,
        actionGetExternalTraining: actionForState(state.action, 'error')
      };
    case 'SAVE_SETTINGS':
      return {
        ...state,
        airportSettings: action.data,
        actionPortalTrainingsFetch: actionForState(state.action, 'success')
      };
    case 'SAVE_OTP':
      return {
        ...state,
        otp: action.otp,
        actionPortalTrainingsFetch: actionForState(state.action, 'success')
      };
    case 'SAVE_CURRENT_PAGE':
      return {
        ...state,
        currentPage: action.currentPage,
        actionPortalTrainingsFetch: actionForState(state.action, 'success')
      };
    case 'SAVE_USER_DATA':
      return {
        ...state,
        userData: action.userData,
        actionPortalTrainingsFetch: actionForState(state.action, 'success')
      };
    case CLEAR_INITIATED_PERMIT_STATE:
      return {
        ...state,
        checkInitiatedPermitAction: {
          loading: false,
          success: false,
          error: false
        },
        initiatedPermitData: {}
    };
    case CLEAR_APPROVED_APPLICATION_STATE:
      return {
        ...state,
        checkApprovedApplicationAction: {
          loading: false,
          success: false,
          error: false
        },
        approvedApplicationData: {},
        submittedDp: {},
        actionSubmitDp: {
          loading: false,
          success: false,
          error: false
        },
        actionSaveAsDraft: {
          loading: false,
          success: false,
          error: false
        },
        actionDeleteDraftADPApplication: {
          loading: false,
          success: false,
          error: false
        }
      };
    case FETCH_AVP_LOGS.pending:
      return {
        ...state,
        avpInitiationStatus: {
          loading: true,
          success: false,
          error: false
        },
        actionPortalTrainingsFetch: actionForState(state.action, 'pending')
      };
    case FETCH_AVP_LOGS.success:
      return {
        ...state,
        avpInitiationStatus: {
          loading: false,
          success: false,
          error: false
        },
        Avp_logs: action?.payload?.results,
        Avp_summary: action?.payload?.summary,
        Avp_filteroptions: action?.payload?.filter_options,
        totalAvpLogsCount: action?.payload?.count,
        actionPortalTrainingsFetch: actionForState(state.action, 'success'),
        enable_initial_review: action?.payload?.enable_initial_review || false
      };
    case FETCH_AVP_LOGS.error:
      return {
        ...state,
        avpInitiationStatus: {
          loading: false,
          success: false,
          error: false
        },
        actionPortalTrainingsFetch: actionForState(state.action, 'error')
      };
    case FETCH_SPECIFIC_AVP_LOGS.pending:
      return {
        ...state,
        loading: false,
        loader: true,
        actionPortalTrainingsFetch: actionForState(state.action, 'pending'),
        getAvpDetailStatus: actionForState(state.action, 'pending')
      };
    case FETCH_SPECIFIC_AVP_LOGS.success:
      return {
        ...state,
        avpSpecificLog: action.payload,
        avpSettings: action.payload?.settings,
        avpDSchema: action.payload?.schema?.default_fields?.default_field || [],
        avpCSchema: action.payload?.schema?.schema?.fields || [],
        avpRequiredAttachments: action.payload?.schema?.default_fields?.required_attachements || [],
        avp_Notes: action.payload?.schema?.default_fields?.notes || [],
        avpOrder: action.payload?.schema?.schema?.ordering || [],
        getAvpDetailStatus: actionForState(state.action, 'success'),
        loader: false,
        actionPortalTrainingsFetch: actionForState(state.action, 'success'),
        suspendApplicationAction: {
          loading: false,
          success: false,
          error: false
        },
        revokeApplicationAction: {
          loading: false,
          success: false,
          error: false
        },
        suspendAVPApplicationAction: {
          loading: false,
          success: false,
          error: false
        },
        revokeAVPApplicationAction: {
          loading: false,
          success: false,
          error: false
        },
        adpAvpCancelAplicationAction: {
          loading: false,
          success: false,
          error: false
        }
      };
    case FETCH_SPECIFIC_AVP_LOGS.error:
      toast.error('Please try again some time');
      return {
        ...state,
        loader: false,
        avpSpecificLog: {},
        getAvpDetailStatus: actionForState(state.action, 'error'),
        actionPortalTrainingsFetch: actionForState(state.action, 'error')
      };
    case FETCH_SCHEDULE_SLOTS_BY_DATE.pending:
      return {
        ...state,
        actionScheduleSlotsFetch: actionForState(state.action, 'pending')
      };
    case FETCH_SCHEDULE_SLOTS_BY_DATE.success:
      return {
        ...state,
        scheduleSlots: action.payload,
        actionScheduleSlotsFetch: actionForState(state.action, 'success')
      };
    case FETCH_SCHEDULE_SLOTS_BY_DATE.error:
      return {
        ...state,
        actionScheduleSlotsFetch: actionForState(state.action, 'error')
      };
    case CLEAR_BOOKING_SCHEDULE:
      return {
        ...state,
        actionScheduleSlotsFetch: {
          loading: false,
          success: false,
          error: false
        },
        scheduleSlots: []
      };

    case FETCH_SCHEDULES.pending:
      return {
        ...state,
        actionScheduleFetch: actionForState(state.action, 'pending')
      };
    case FETCH_SCHEDULES.success:
      return {
        ...state,
        scheduleList: action.payload,
        actionScheduleFetch: actionForState(state.action, 'success')
      };
    case FETCH_SCHEDULES.error:
      return {
        ...state,
        actionScheduleFetch: actionForState(state.action, 'error')
      };
    case SCHEDULE_APPOINTMENT.pending:
      return {
        ...state,
        actionScheduled: actionForState(state.action, 'pending')
      };
    case SCHEDULE_APPOINTMENT.success:
      return {
        ...state,
        actionScheduled: actionForState(state.action, 'success'),
        scheduledSlot: action.payload
      };
    case SCHEDULE_APPOINTMENT.error:
      return {
        ...state,
        actionScheduled: actionForState(state.action, 'error'),
        schedulingErrorResponse: action.payload?.response?.data?.message
      };
    case RESCHEDULE_APPOINTMENT.pending:
      return {
        ...state,
        actionRescheduled: actionForState(state.action, 'pending')
      };
    case RESCHEDULE_APPOINTMENT.success:
      return {
        ...state,
        actionRescheduled: actionForState(state.action, 'success'),
        RescheduledSlot: action.payload
      };
    case RESCHEDULE_APPOINTMENT.error:
      return {
        ...state,
        actionRescheduled: actionForState(state.action, 'error'),
        schedulingErrorResponse: action.payload?.response?.data?.message
      };
    case INITIATE_AVP_APPLICATION.pending:
      return {
        ...state,
        avpInitiationStatus: {
          loading: true,
          success: false,
          error: false
        },
        actionPortalTrainingsFetch: actionForState(state.action, 'pending')
      };
    case INITIATE_AVP_APPLICATION.success:
      return {
        ...state,
        avpInitiationStatus: {
          loading: false,
          success: true,
          error: false
        },
        avpInitiationInfo: action.payload,
        actionPortalTrainingsFetch: actionForState(state.action, 'success')
      };
    case INITIATE_AVP_APPLICATION.error:
      if (action.payload?.response?.data?.detail !== PERMIT_ALREADY_RENEWED) {
        toast.error('Please try after some time');
      }
      return {
        ...state,
        avpInitiationStatus: {
          loading: false,
          success: false,
          error: true
        },
        errorResponse: action.payload?.response?.data?.detail,
        actionPortalTrainingsFetch: actionForState(state.action, 'error')
      };
    case AVP_DEFAULT_FIELDS.pending:
      return {
        ...state,
        avpDefaultFields: action.payload,
        avpInitiationStatus: {
          loading: true,
          success: false,
          error: false
        },
        actionPortalTrainingsFetch: actionForState(state.action, 'pending')
      };

    case GET_AVP_CATEGORIES.pending:
      return {
        ...state,
        actionGetAvpCategories: actionForState(state.action, 'pending')
      };

    case GET_AVP_CATEGORIES.success:
      return {
        ...state,
        avpCategoryList: action.payload,
        actionGetAvpCategories: actionForState(state.action, 'success')
      };

    case GET_AVP_CATEGORIES.error:
      return {
        ...state,
        actionGetAvpCategories: actionForState(state.action, 'error')
      };

    case GET_AVP_FEE_MATRIX.pending:
      return {
        ...state,
        getAvpFeeMatrixAction: actionForState(state.action, 'pending')
    };
    case GET_AVP_FEE_MATRIX.success:
      return {
        ...state,
        avpFeeMatrix: action?.payload,
        getAvpFeeMatrixAction: actionForState(state.action, 'success')
    };
    case GET_AVP_FEE_MATRIX.error:
      return {
        ...state,
        getAvpFeeMatrixAction: actionForState(state.action, 'error')
    };
    case GET_AVP_COMMENTS.pending:
      return {
        ...state,
        getAvpCommentsAction: actionForState(state.action, 'pending')
      };
    case GET_AVP_COMMENTS.success:
      return {
        ...state,
        comments: action.payload,
        getAvpCommentsAction: actionForState(state.action, 'success')
      };
    case GET_AVP_COMMENTS.error: {
      return {
        ...state,
        getAvpCommentsAction: actionForState(state.action, 'error')
      };
    }

    case MAKE_AVP_PAYMENT.pending:
      return {
        ...state,
        getAvpPaymentAction: actionForState(state.action, 'pending')
    };
    case MAKE_AVP_PAYMENT.success:
      return {
        ...state,
        getAvpPaymentAction: actionForState(state.action, 'success')
    };
    case MAKE_AVP_PAYMENT.error:
      toast.error('Please try after some time');
      return {
        ...state,
        getAvpPaymentAction: actionForState(state.action, 'error')
    };

    case ADP_AVP_CANCEL_APPLICATION.pending:
      return {
        ...state,
        adpAvpCancelAplicationAction: actionForState(state.action, 'pending')
      };
    case ADP_AVP_CANCEL_APPLICATION.success:
      toast.success('Updated Successfully');
      return {
        ...state,
        cancellationResponse: action.payload || {},
        adpAvpCancelAplicationAction: actionForState(state.action, 'success')
      };
    case ADP_AVP_CANCEL_APPLICATION.error:
      toast.error('Please try after some time');
      return {
        ...state,
        adpAvpCancelAplicationAction: actionForState(state.action, 'error')
      };
    case CLEAR_CANCEL_STATE:
      return {
        ...state,
        adpAvpCancelAplicationAction: {
          loading: false,
          success: false,
          error: false
        }
      };
    case AVP_DEFAULT_FIELDS.success:
      return {
        ...state,
        avpInitiationStatus: {
          loading: false,
          success: false,
          error: false
        },
        avpOrdering: action.payload?.schema?.schema?.ordering || [],
        avpDefaultFields: action.payload?.schema?.default_fields?.default_fields || [],
        avpCustomFields: action.payload?.schema?.schema?.fields || [],
        avpRenewalFields: action.payload?.schema?.renewal_fields || [],
        avpNotes: action.payload?.schema?.default_fields?.notes,
        avpReqAttachments: action.payload?.schema?.default_fields?.required_attachements || [],
        avpSettings: action.payload?.settings?.settings || {},
        avpGetSchemaSettings: action.payload?.settings || {},
        actionPortalTrainingsFetch: actionForState(state.action, 'success')
      };
    case AVP_DEFAULT_FIELDS.error:
      toast.error('Please try after some time');
      return {
        ...state,
        avpInitiationStatus: {
          loading: false,
          success: false,
          error: false
        },
        avpDefaultFields: [],
        actionPortalTrainingsFetch: actionForState(state.action, 'error')
      };

      // ADP_DEFAULT_FIELDS

    case ADP_DEFAULT_FIELDS.pending:
      return {
        ...state,
        adpDefaultFields: action.payload,
        avpInitiationStatus: {
          loading: true,
          success: false,
          error: false
        },
        actionPortalTrainingsFetch: actionForState(state.action, 'pending'),
        // this keyword used only for checking the ADP get_schema
        adpGetSchemaStatus: actionForState(state.action, 'pending')
      };
    case ADP_DEFAULT_FIELDS.success:
      return {
        ...state,
        avpInitiationStatus: {
          loading: false,
          success: true,
          error: false
        },
        adpSchemaSettings: action.payload?.settings || {},
        adpDefaultFields: action.payload?.settings?.settings || {},
        adpSchema: action.payload?.schema || {},
        AdpDSchema: action.payload?.schema?.default_fields?.default_field || [],
        adpRenewalFields: action.payload?.schema?.renewal_fields?.fields || [],
        AdpCSchema: action.payload?.schema?.schema?.fields || [],
        AdpOrder: action.payload?.schema?.schema?.ordering || [],
        // this keyword used only for checking the ADP get_schema
        adpGetSchemaStatus: actionForState(state.action, 'success')
      };
    case ADP_DEFAULT_FIELDS.error:
      toast.error('Please try after some time');
      return {
        ...state,
        avpInitiationStatus: {
          loading: false,
          success: false,
          error: true
        },
        adpDefaultFields: [],
        actionPortalTrainingsFetch: actionForState(state.action, 'error'),
        // this is the keyword use only for checking the status of ADP get_schema
        adpGetSchemaStatus: actionForState(state.action, 'error')
      };

    case RENEWAL_DAYS.pending:
      return {
        ...state,
        renewaldays: action.payload,
        renewalStatus: {
          loading: true,
          success: false,
          error: false
        },
        actionPortalTrainingsFetch: actionForState(state.action, 'pending')
      };
    case RENEWAL_DAYS.success:
      return {
        ...state,
        renewaldays: action.payload,
        renewalStatus: {
          loading: false,
          success: false,
          error: false
        },
        actionPortalTrainingsFetch: actionForState(state.action, 'success')
      };
    case RENEWAL_DAYS.error:
      toast.error('Please try after some time');
      return {
        ...state,
        renewalStatus: {
          loading: false,
          success: false,
          error: false
        },
        actionPortalTrainingsFetch: actionForState(state.action, 'error')
      };


    case AVP_GLOBAL_DATASOURCE_LIST.pending:
      return {
        ...state,
        actionGetGlobalDatasoruce: actionForState(state.action, 'pending')
      };
    case AVP_GLOBAL_DATASOURCE_LIST.success:
      return {
        ...state,
        actionGetGlobalDatasoruce: actionForState(state.action, 'success'),
        avpGlobalDatasourceList: {
          ...state.avpGlobalDatasourceList,
          [action.fieldId]: action.payload
        }
      };
    case AVP_GLOBAL_DATASOURCE_LIST.error:
      toast.error('Please try after some time');
      return {
        ...state,
        actionGetGlobalDatasoruce: actionForState(state.action, 'error')
      };

    case ADP_SUSPEND_ACTION.pending: {
      return {
        ...state,
        suspendApplicationAction: actionForState(state.action, 'pending')
      };
    }

    case ADP_SUSPEND_ACTION.success: {
      toast.success('Updated Successfully');
      return {
        ...state,
        suspendApplicationAction: actionForState(state.action, 'success')
      };
    }

    case ADP_SUSPEND_ACTION.error: {
      toast.error('Please try again later');
      return {
        ...state,
        suspendApplicationAction: actionForState(state.action, 'error')
      };
    }

    case CLEAR_PAYMENT_STATE:
      return {
        ...state,
        makeAdpPaymentAction: {
          loading: false,
          success: false,
          error: false
        },
        paymentRedirectUrl: '',
        adpPaymentDetail: ''
      };

    case CLEAR_DETAILS:
      return {
        ...state,
        makeAdpPaymentAction: {
          loading: false,
          success: false,
          error: false
        },
        paymentRedirectUrl: '',
        adpPaymentDetail: '',
        getApplicationResponse: {},
        getADPdetailsStatus: {
          loading: false,
          success: false,
          error: false
        },
        adpFeeWithCategoriesList: [],
        specificLog: {}
      };

    case CLEAR_ADP_DETAILS_STATUS: {
      return {
        ...state,
        getADPdetailsStatus: {
          loading: false,
          success: false,
          error: false
        }
      };
    }

    case ADP_REVOKE_ACTION.pending: {
      return {
        ...state,
        revokeApplicationAction: actionForState(state.action, 'pending')
      };
    }

    case ADP_REVOKE_ACTION.success: {
      toast.success('Updated Successfully');
      return {
        ...state,
        revokeApplicationAction: actionForState(state.action, 'success')
      };
    }

    case ADP_REVOKE_ACTION.error: {
      toast.error('Please try again later');
      return {
        ...state,
        revokeApplicationAction: actionForState(state.action, 'error')
      };
    }

    case AVP_SUSPEND_ACTION.pending: {
      return {
        ...state,
        suspendAVPApplicationAction: actionForState(state.action, 'pending')
      };
    }

    case AVP_SUSPEND_ACTION.success: {
      toast.success('Updated Successfully');
      return {
        ...state,
        suspendAVPApplicationAction: actionForState(state.action, 'success')
      };
    }

    case AVP_SUSPEND_ACTION.error: {
      toast.error('Please try again later');
      return {
        ...state,
        suspendAVPApplicationAction: actionForState(state.action, 'error')
      };
    }

    case AVP_REVOKE_ACTION.pending: {
      return {
        ...state,
        revokeAVPApplicationAction: actionForState(state.action, 'pending')
      };
    }

    case AVP_REVOKE_ACTION.success: {
      toast.success('Updated Successfully');
      return {
        ...state,
        revokeAVPApplicationAction: actionForState(state.action, 'success')
      };
    }

    case AVP_REVOKE_ACTION.error: {
      toast.error('Please try again later');
      return {
        ...state,
        revokeAVPApplicationAction: actionForState(state.action, 'error')
      };
    }

    case GET_ADP_APPLICATION_STAGE.pending: {
      return {
        ...state,
        getAdpApplicationStage: actionForState(state.action, 'pending')
      };
    }
    case GET_ADP_APPLICATION_STAGE.success: {
      return {
        ...state,
        adpApplicationStage: action.payload,
        appData: {
          ...state.appData,
          ...action.payload
        },
        getAdpApplicationStage: actionForState(state.action, 'success')
      };
    }
    case GET_ADP_APPLICATION_STAGE.error: {
      return {
        ...state,
        getAdpApplicationStage: actionForState(state.action, 'error')
      };
    }

    case CLEAR_STAGES_STATE: {
      return {
        ...state,
        adpApplicationStage: {},
        getAdpApplicationStage: {
          loading: false,
          success: false,
          error: false
        }
      };
    }

    case CLEAR_APPLICATION_STATUS: {
      return {
        ...state,
        actionApplicationDetails: {
          loading: false,
          success: false,
          error: false
        }
      };
    }

    case UPLOAD_AVP_ATTACHMENTS.pending: {
      return {
        ...state,
        uploadAvpDocuments: actionForState(state.action, 'pending')
      };
    }

    case UPLOAD_AVP_ATTACHMENTS.success: {
      toast.success('Updated Successfully');
      return {
        ...state,
        uploadAvpDocuments: actionForState(state.action, 'success')
      };
    }

    case UPLOAD_AVP_ATTACHMENTS.error: {
      toast.error('Please try again later');
      return {
        ...state,
        uploadAvpDocuments: actionForState(state.action, 'error')
      };
    }

    case DELETE_SPECIFIC_ADP_LOGS.pending:
      toast.success('Deleted successfully');
      return {
        ...state,
        deletionStatus: {
          loading: true,
          success: false,
          error: false
        },
        actionPortalTrainingsFetch: actionForState(state.action, 'success')
      };
    case DELETE_SPECIFIC_ADP_LOGS.success:
      toast.success('Deleted successfully');
      return {
        ...state,
        deletionStatus: {
          loading: false,
          success: true,
          error: false
        },
        actionPortalTrainingsFetch: actionForState(state.action, 'success')
      };
    case DELETE_SPECIFIC_ADP_LOGS.error:
      toast.error('Please try after some time');
      return {
        ...state,
        deletionStatus: {
          loading: false,
          success: true,
          error: false
        },
        actionPortalTrainingsFetch: actionForState(state.action, 'error')
      };
    case ADP_RE_APPLY.pending:
      return {
        ...state,
        adp_Reapply_Status: {
          loading: true,
          success: false,
          error: false
        },
        actionPortalTrainingsFetch: actionForState(state.action, 'success')
      };
    case ADP_RE_APPLY.success:
      toast.success('Applied Successfully');
      return {
        ...state,
        adp_Reapply_Status: {
          loading: false,
          success: true,
          error: false
        },
        actionPortalTrainingsFetch: actionForState(state.action, 'success')
      };
    case ADP_RE_APPLY.error:
      toast.error('Please try after some time');
      return {
        ...state,
        adp_Reapply_Status: {
          loading: false,
          success: false,
          error: true
        },
        actionPortalTrainingsFetch: actionForState(state.action, 'error')
      };
    case AVP_RE_APPLY.pending:
      return {
        ...state,
        avp_Reapply_Status: {
          loading: true,
          success: false,
          error: false
        },
        actionPortalTrainingsFetch: actionForState(state.action, 'success')
      };
    case AVP_RE_APPLY.success:
      toast.success('Applied Successfully');
      return {
        ...state,
        avp_Reapply_Status: {
          loading: false,
          success: true,
          error: false
        },
        actionPortalTrainingsFetch: actionForState(state.action, 'success')
      };
    case AVP_RE_APPLY.error:
      toast.error('Please try after some time');
      return {
        ...state,
        avp_Reapply_Status: {
          loading: false,
          success: false,
          error: true
        },
        actionPortalTrainingsFetch: actionForState(state.action, 'error')
      };
    case UPDATE_REQUIRED_DOCUMENTS.pending: {
      return {
        ...state,
        updateRequiredDocumentsAction: actionForState(state.action, 'pending')
      };
    }
    case UPDATE_REQUIRED_DOCUMENTS.success: {
      toast.success('Updated Successfully');
      return {
        ...state,
        updateRequiredDocumentsAction: actionForState(state.action, 'success')
      };
    }
    case UPDATE_REQUIRED_DOCUMENTS.error: {
      toast.error('Please try again later');
      return {
        ...state,
        updateRequiredDocumentsAction: actionForState(state.action, 'error')
      };
    }
    case AVP_RE_PRINT.pending:
      return {
        ...state,
        avpRePrintStatus: {
          loading: true,
          success: false,
          error: false
        }
      };
    case AVP_RE_PRINT.success:
      toast.success('Requested successfully');
      return {
        ...state,
        avpRePrintStatus: {
          loading: false,
          success: true,
          error: false
        }
      };
    case AVP_RE_PRINT.error:
      toast.error('Please try after some time');
      return {
        ...state,
        avpRePrintStatus: {
          loading: false,
          success: false,
          error: true
        }
      };
    case ADP_RE_PRINT.pending:
      return {
        ...state,
        adpRePrintStatus: {
          loading: true,
          success: false,
          error: false
        }
      };
    case ADP_RE_PRINT.success:
      toast.success('Requested successfully');
      return {
        ...state,
        adpRePrintStatus: {
          loading: false,
          success: true,
          error: false
        }
      };
    case ADP_RE_PRINT.error:
      toast.error('Please try after some time');
      return {
        ...state,
        adpRePrintStatus: {
          loading: false,
          success: false,
          error: true
        }
      };
    case CLEAR_REPRINT_STATE:
      return {
        ...state,
        adpRePrintStatus: {
          loading: false,
          success: false,
          error: false
        },
        avpRePrintStatus: {
          loading: false,
          success: false,
          error: false
        }
      };
    case FETCH_USER_APPLICATIONS:
      return {
        ...state,
        userApplications: action.payload
      };
    case GET_DEFECT_VEHICLES.pending:
      return {
        ...state,
        defectVehiclesAction: actionForState(state.action, 'pending')
      };
    case GET_DEFECT_VEHICLES.success:
      return {
        ...state,
        defectVehicles: action.payload,
        defectVehiclesAction: actionForState(state.action, 'success')
      };
    case GET_DEFECT_VEHICLES.error:
      return {
        ...state,
        defectVehiclesAction: actionForState(state.action, 'error')
      };
    case GET_DEFECT_VEHICLE_DETAIL.pending:
      return {
        ...state,
        defectVehicleAction: actionForState(state.action, 'pending')
      };
    case GET_DEFECT_VEHICLE_DETAIL.success:
      return {
        ...state,
        defectVehicleDetail: action.payload,
        defectVehicleAction: actionForState(state.action, 'success')
      };
    case GET_DEFECT_VEHICLE_DETAIL.error:
      return {
        ...state,
        defectVehicleAction: actionForState(state.action, 'error')
      };
    case UPDATE_MAINTENANCE.pending:
      return {
        ...state,
        updateDefectAction: actionForState(state.action, 'pending')
      };
    case UPDATE_MAINTENANCE.success:
      toast.success('Updated Successfully');
      return {
        ...state,
        updateDefectAction: actionForState(state.action, 'success')
      };
    case UPDATE_MAINTENANCE.error:
      toast.error('Please try after some time');
      return {
        ...state,
        updateDefectAction: actionForState(state.action, 'error')
      };
    case POST_COMMENTS.pending:
      return {
        ...state,
        commentDefectAction: actionForState(state.action, 'pending')
      };
    case POST_COMMENTS.success:
      return {
        ...state,
        commentDefectAction: actionForState(state.action, 'success')
      };
    case POST_COMMENTS.error:
      toast.error('Please try after some time');
      return {
        ...state,
        commentDefectAction: actionForState(state.action, 'error')
      };
      case GET_COMMENTS.pending:
        return {
          ...state,
          getcommentDefectAction: actionForState(state.action, 'pending')
        };
      case GET_COMMENTS.success:
        return {
          ...state,
          comments: action.payload,
          getcommentDefectAction: actionForState(state.action, 'success')
        };
      case GET_COMMENTS.error:
        return {
          ...state,
          getcommentDefectAction: actionForState(state.action, 'error')
        };
        case APPEAL_VIOLATION.pending:
          toast.success('Appealed Successfully');
          return {
            ...state,
            violationAppealAction: actionForState(state.action, 'pending')
          };
        case APPEAL_VIOLATION.success:
          return {
            ...state,
            violationAppealAction: actionForState(state.action, 'success')
          };
        case APPEAL_VIOLATION.error:
          toast.error('Please try after some time');
          return {
            ...state,
            violationAppealAction: actionForState(state.action, 'error')
          };
    case CLEAR_STATE:
      return {
        ...state,
        scheduleSlots: undefined,
        scheduleList: undefined,
        actionScheduleSlotsFetch: {
          loading: false,
          success: false,
          error: false
        },
        errorResponse: undefined,
        schedulingErrorResponse: undefined,
        adpInitiationStatus: {
          loading: false,
          success: false,
          error: false
        },
        adp_Reapply_Status: {
          loading: false,
          success: false,
          error: false
        },
        actionScheduleFetch: {
          loading: false,
          success: false,
          error: false
        },
        actionScheduled: {
          loading: false,
          success: false,
          error: false
        },
        actionRescheduled: {
          loading: false,
          success: false,
          error: false
        }
      };

      case CLEAR_DRAFT_STATE:
        return {
          ...state,
          avpSpecificLog: {},
          userData: {},
          applicationDetails: {},
          avpFeeMatrix: [],
          avp_Reapply_Status: {
            loading: false,
            success: false,
            error: false
          },
          avpDraftStatus: {
            loading: false,
            success: false,
            error: false
          },
          makeAdpPaymentAction: {
            loading: false,
            success: false,
            error: false
          },
          initiateDraftApplicationAction: {
            loading: false,
            success: false,
            error: false
          },
          actionDeleteDraftADPApplication: {
            loading: false,
            success: false,
            error: false
          },
          actionDeleteDraftAVPApplication: {
            loading: false,
            success: false,
            error: false
          },
          getAvpPaymentAction: {
            loading: false,
            success: false,
            error: false
          }
        };

      case INITIATE_DRAFT_APPLICATION.pending:
        return {
          ...state,
          initiateDraftApplicationAction: actionForState(state.action, 'pending')
        };

      case INITIATE_DRAFT_APPLICATION.success:
        return {
          ...state,
          initiateDraftApplicationAction: actionForState(state.action, 'success')
        };

      case INITIATE_DRAFT_APPLICATION.error:
        return {
          ...state,
          initiateDraftApplicationAction: actionForState(state.action, 'error')
        };

      case GET_MY_APPLICATIONS.pending:
        return {
          ...state,
          actionMyApplications: actionForState(state.action, 'pending')
        };
      case GET_MY_APPLICATIONS.success:
        return {
          ...state,
          myApplications: action.payload,
          actionMyApplications: actionForState(state.action, 'success')
        };
      case GET_MY_APPLICATIONS.error:
        return {
          ...state,
          actionMyApplications: actionForState(state.action, 'error')
        };
      case GET_PORTAL_USERS.pending:
        return {
          ...state,
          actionPortalUsers: actionForState(state.action, 'pending')
        };
      case GET_PORTAL_USERS.success:
        return {
          ...state,
          portalUsers: action.payload,
          actionPortalUsers: actionForState(state.action, 'success')
        };
      case GET_PORTAL_USERS.error:
        return {
          ...state,
          actionPortalUsers: actionForState(state.action, 'error')
        };
      case AVP_DRAFT_APPLICATION.pending:
        return {
          ...state,
          avpDraftStatus: actionForState(state.action, 'pending')
        };

      case AVP_DRAFT_APPLICATION.success:
        return {
          ...state,
          avpDraftStatus: actionForState(state.action, 'success')
        };

      case AVP_DRAFT_APPLICATION.error:
        return {
          ...state,
          avpDraftStatus: actionForState(state.action, 'error')
        };
      case GET_APPLICATION_DETAILS.pending:
        return {
          ...state,
          actionApplicationDetails: actionForState(state.action, 'pending')
        };
      case GET_APPLICATION_DETAILS.success: {
        let isPaymentAvailable = false;
        let { permit_tenant_fees } = action.payload?.permit?.fees_settings || {};

        if (action.payload?.permit?.fees_settings?.enable_permit_fees_adp) {
          if (permit_tenant_fees?.charge_fees_per_adp_permit) {
            isPaymentAvailable = permit_tenant_fees?.charge_fees_per_adp_permit;
          }
        }
        let { isScheduleEnable } = state;
        if ('scheduleEnable' in action.payload) {
          isScheduleEnable = action.payload?.scheduleEnable;
        }
        return {
          ...state,
          applicationDetails: action.payload,
          userData: action.userData,
          appData: action.payload?.permit || {},
          actionApplicationDetails: actionForState(state.action, 'success'),
          isPaymentAvailable,
          isScheduleEnable
        };
      }
      case GET_APPLICATION_DETAILS.error:
        return {
          ...state,
          actionApplicationDetails: actionForState(state.action, 'error')
        };

      case UPDATE_DP.pending:
        return {
          ...state,
          actionUpdateDp: actionForState(state.action, 'pending')
        };
      case UPDATE_DP.success:
        return {
          ...state,
          actionUpdateDp: actionForState(state.action, 'success'),
          updatedDp: action.payload
        };
      case UPDATE_DP.error:
        return {
          ...state,
          actionUpdateDp: actionForState(state.action, 'error')
        };
        case RETAKE_TRAINING.pending:
          return {
            ...state,
            actionRetakeTraining: actionForState(state.action, 'pending')
          };
        case RETAKE_TRAINING.success:
          return {
            ...state,
            actionRetakeTraining: actionForState(state.action, 'success'),
            updatedDp: action.payload
          };
        case RETAKE_TRAINING.error:
          return {
            ...state,
            actionRetakeTraining: actionForState(state.action, 'error')
          };
      case SUBMIT_DP.pending:
        return {
          ...state,
          actionSubmitDp: actionForState(state.action, 'pending')
        };
      case SUBMIT_DP.success:
        return {
          ...state,
          actionSubmitDp: actionForState(state.action, 'success'),
          submittedDp: action.payload
        };
      case SUBMIT_DP.error:
        return {
          ...state,
          actionSubmitDp: actionForState(state.action, 'error')
        };
      case SAVE_AS_DRAFT.pending:
        return {
          ...state,
          actionSaveAsDraft: actionForState(state.action, 'pending')
        };
      case SAVE_AS_DRAFT.success:
        return {
          ...state,
          actionSaveAsDraft: actionForState(state.action, 'success'),
          submittedDp: action.payload,
          applicationDetails: action.payload
        };
      case SAVE_AS_DRAFT.error:
        return {
          ...state,
          actionSaveAsDraft: actionForState(state.action, 'error')
        };

      case EMPTY_UPDATE_DP:
        return {
          ...state,
          updatedDp: {}
        };

      case GET_CURRENT_TENANT_PORTAL_USERS.pending:
        return {
          ...state,
          actionPortalUsers: actionForState(state.action, 'pending')
        };
      case GET_CURRENT_TENANT_PORTAL_USERS.success:
        return {
          ...state,
          currentTenantPortalUsers: action.payload,
          actionPortalUsers: actionForState(state.action, 'success')
        };
      case GET_CURRENT_TENANT_PORTAL_USERS.error:
        return {
          ...state,
          actionPortalUsers: actionForState(state.action, 'error')
        };
        case CLEAR_IMPORT_AVP_STATE:
          return {
            ...state,
            importAvpdataAction: {
              success: false,
              loading: false,
              error: false
            }
          };
        case IMPORT_AVP_LOGS_DATA.pending:
          return {
            ...state,
            importAvpdataAction: actionForState(state.action, 'pending')
          };
        case IMPORT_AVP_LOGS_DATA.success:
          if (action.payload.error) {
            toast.error('Error occured while creating records');
          } else {
            toast.success('Records Created Successfully');
          }
          return {
            ...state,
            importResponse: action.payload,
            importAvpdataAction: actionForState(state.action, 'success')
          };
        case IMPORT_AVP_LOGS_DATA.error:
          toast.error('Error occured while creating records');
          return {
            ...state,
            importResponse: undefined,
            importAvpdataAction: actionForState(state.action, 'error')
          };
          case ADDITIONAL_DRIVER_PERMIT_DOCS.pending:
            return {
              ...state,
              additionalDocsAction: actionForState(state.action, 'pending')
            };
          case ADDITIONAL_DRIVER_PERMIT_DOCS.success:
            toast.success(action?.payload?.msg || 'Document added Successfully');
            return {
              ...state,
              specificLog: {
                ...state.specificLog,
                attachments: action?.payload?.attachments,
                additional_attachments: action?.payload?.additional_attachments
              },
              additionalDocsAction: actionForState(state.action, 'success')
            };
          case ADDITIONAL_DRIVER_PERMIT_DOCS.error: {
            toast.error('Please try again later');
            return {
              ...state,
              additionalDocsAction: actionForState(state.action, 'error')
            };
          }
          case ADDITIONAL_VEHICLE_PERMIT_DOCS.pending:
            return {
              ...state,
              additionalDocsAction: actionForState(state.action, 'pending')
            };
          case ADDITIONAL_VEHICLE_PERMIT_DOCS.success:
            toast.success(action.payload?.message || 'Document Added Successfully');
            return {
              ...state,
              avpSpecificLog: {
                ...state.avpSpecificLog,
                attachments: action?.payload?.data?.attachments,
                additional_attachments: action?.payload?.data?.additional_attachments
              },
              additionalDocsAction: actionForState(state.action, 'success')
            };
          case ADDITIONAL_VEHICLE_PERMIT_DOCS.error: {
            toast.error('Please try again later');
            return {
              ...state,
              additionalDocsAction: actionForState(state.action, 'error')
            };
          }
          case DELETE_SAVE_AS_DRAFT_ADP_LOGS.pending:
          return {
            ...state,
            actionDeleteDraftADPApplication: actionForState(state.action, 'pending')
          };
        case DELETE_SAVE_AS_DRAFT_ADP_LOGS.success:
          return {
            ...state,
            actionDeleteDraftADPApplication: actionForState(state.action, 'success')
          };
        case DELETE_SAVE_AS_DRAFT_ADP_LOGS.error:
          return {
            ...state,
            actionDeleteDraftADPApplication: actionForState(state.action, 'error')
          };
        case DELETE_SAVE_AS_DRAFT_AVP_LOGS.pending:
          return {
            ...state,
            actionDeleteDraftAVPApplication: actionForState(state.action, 'pending')
          };
        case DELETE_SAVE_AS_DRAFT_AVP_LOGS.success:
          return {
            ...state,
            actionDeleteDraftAVPApplication: actionForState(state.action, 'success')
          };
        case DELETE_SAVE_AS_DRAFT_AVP_LOGS.error:
          return {
            ...state,
            actionDeleteDraftAVPApplication: actionForState(state.action, 'error')
          };
          case GET_LOGS_EXCEL_EXPORT.pending:
            return {
              ...state,
              excleLoader: actionForState(state.action, 'pending')
            };
          case GET_LOGS_EXCEL_EXPORT.success:
            return {
              ...state,
              excleLoader: actionForState(state.action, 'success'),
              excelData: action.payload.results
            };
          case GET_LOGS_EXCEL_EXPORT.error: {
            return {
              ...state,
              excleLoader: actionForState(state.action, 'error')
            };
          }
          case FETCH_AVP_LOGS_TO_EXPORT.pending:
            return {
              ...state,
              AvpexcleLoader: actionForState(state.action, 'pending')
            };
          case FETCH_AVP_LOGS_TO_EXPORT.success:
            return {
              ...state,
              AvpexcleLoader: actionForState(state.action, 'success'),
              AvpexcelData: action.payload.results
            };
          case FETCH_AVP_LOGS_TO_EXPORT.error: {
            return {
              ...state,
              AvpexcleLoader: actionForState(state.action, 'error')
            };
          }

    default:
      return state;
  }
}
